import { Roboto, Galada, Noto_Sans } from 'lib/fonts/local-font-references';

const roboto = Roboto({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-roboto',
  weight: ['400', '700'],
});

const galada = Galada({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-galada',
  weight: ['400'],
});

const notoSans = Noto_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-noto-sans',
  weight: ['400', '700'],
});

export const supportedFonts = [roboto, galada, notoSans];
